import React from 'react'
import Button from '@material-ui/core/Button'
import AQUGpdf from '../../../docs/AQcast_SCICHEM_User_Guide.pdf'
import AERMODAQUG from '../../../docs/AQcast_AERMOD_User_Guide.pdf'

import { Link } from 'react-router-dom'


class NoAuthHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div >
                <h2> Air Quality Modeling Made Easy on the Cloud </h2>

                AER's AQcast modeling system contains a variety of air quality models and their preprocessors and deploys them on the Amazon
                Web Services (AWS) cloud.  These pre-compiled and easy to use program packages can be accessed by outside users via the web
                using a secure interface. No software download or installation is needed.  AQcast automatically collects the needed inputs and
                runs the models on the AWS cloud, requiring NO use of your local machines.  In addition, using the AWS cloud allows each model
                to use an unlimited number of CPUs and RAM to reduce runtime.  The user will be emailed when their project has completed.
                Updates are done regularly and require no action by the user.


                <h2> Models Available: </h2>
                <h4>-AERMOD</h4>

                <p>EPA approved dispersion model for NAAQS and other hazardous air pollutants. Using AQcast on the Amazon cloud, AER
                can run AERMOD and all of its pre-processors (bpipprm, aermap, aermet, aerminute, and aersurface) for a facility
                with provided source parameters and facility location.  AQcast: AERMOD uses the latest approved versions and
                updates are done automatically with no user action required.  AQcast will download and process all necessary terrain, landuse, and
                meteorological data for use in AERMOD. Receptor grids can be specified and run quickly taking advantage of the Amazon Web Services cloud
                computing.  ESRI GIS shapefiles of facility buildings and fence lines can be uploaded and input into the model or the shapes can be drawn
                on the map provided in the user interface.  Following the successful completion of AERMOD, various plots and summary files will be
                displayed on the AQcast: AERMOD access portal, and a link to download all modeling files will be provided.</p>

                <a href={AERMODAQUG} target = "_blank">AQcast: AERMOD User Guide</a>

                <h4>-SCICHEM</h4>

                <p>A reactive non-steady-state plume dispersion model that can be used to calculate single and multi-source emissions downwind as
                well as short and long-range calculations. AQcast: SCICHEM uses the latest version and updates automatically with no user action required.
                AQcast will download and process all necessary terrain and meteorological data files appropriate for the user specified scenario and run SCICHEM.
                ESRI GIS shapefiles of facility buildings and fence lines can be uploaded and input into the model or drawn on the map provided in the user interface.
                Following the successful completion of SCICHEM, various plots and summary files will be displayed on the AQcast: SCICHEM access portal, and a link
                to download all modeling files will be provided.  </p>

                <a href={AQUGpdf} target = "_blank">AQcast: SCICHEM User Guide</a>

                <h3>Model Preview:</h3>
                <p>The AQcast: AERMOD and AQcast: SCICHEM user interfaces can be previewed from the links below. While AERMOD or SCHICHEM jobs cannot be submitted
                from these preview links, you will be able to see the model options, page setup, and view some sample results.</p>

                <Button
                    component={Link}
                    to="/AERMODPreview"
                    style={{color: 'blue'}}
                > <b> - AERMOD </b></Button>
                <div>
                    <Button
                        component={Link}
                        to="/SCICHEMPreview"
                        style={{color: 'blue'}}
                    > <b> - SCICHEM </b></Button>
                </div>

                <h2>Meteorology Data Used in AQcast - "Met Tokens"</h2>
                <p>AQcast gathers and processes meteorological input data based on the facility location. Each annual subscription includes a number of "met tokens" depending on
                the subscription type. A met token will be used if the project creates new MMIF data or processes new NOAA station data. Previously created meteorological
                datasets can be reused without incurring a met token charge.  A met token will be refunded should a model run fail before producing the requested met data.
                Additional met tokens can be purchased for $500 each by emailing AQcast below.</p>
                <p>For AERMOD projects, some states provide their own meteorology input files. A met token will not be used if the facility is located in one of these states.
                Currently  AQcast will automatically pull these datasets based on the facility location for the following states: [TX]. Other states can be added upon
                request - just email AQcast below.</p>

                <h2> Contact Information </h2>
                For more information on how to access these models, email <a href="mailto:AQcast@aer.com"> AQcast@aer.com</a>
                <br></br>
            </div>
        )
    }
}

export default NoAuthHome
